/* nsband: marquee + clique. Otimizado pra celular fraco (navegador do Instagram):
   - marquee e transform puro, roda no compositor
   - fora da tela a animacao PARA (economiza bateria e evita jank em lista longa)
   - brilho por glifo so no desktop e so nas 2 faixas da PDP, nunca no card */
(function () {
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DESK = window.matchMedia && window.matchMedia('(min-width:750px)').matches;
  var PILL = { dragon: 'Hong Kong', gime: 'Jeju', thulite: 'Hong Kong', tourmaline: 'Hong Kong', fluorite: 'Hong Kong', marcasite: 'Día de Muertos', thomsonite: 'Día de Muertos', stilbite: 'Día de Muertos', erythrite: 'Pink October', zoisite: 'Labubu', trona: 'Down Syndrome', anatase: 'Legends', orpiment: 'Legends', uvarovite: 'Independencia', zincite: 'Día de Muertos', inesite: 'Octubre Rosa', eudialyte: 'Octubre Rosa', tugtupite: 'Octubre Rosa', smithsonite: 'Octubre Rosa' };

  // um observer para todas as faixas: liga/desliga a animacao conforme entra e sai da tela
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    for (var i = 0; i < es.length; i++) es[i].target.classList.toggle('is-off', !es[i].isIntersecting);
  }, { rootMargin: '120px 0px' }) : null;

  function shine(band) {
    if (RM || !DESK || band.__sh) return;
    if (band.classList.contains('nsb--card')) return;   // card nunca acende
    band.__sh = 1;
    var gs = band.querySelectorAll('.nsb__g');
    if (!gs.length) return;
    for (var i = 0; i < gs.length; i++) {
      (function (g) { g.addEventListener('animationend', function () { g.classList.remove('is-lit'); }); })(gs[i]);
    }
    var k = 0, t = null;
    function step() {
      if (band.classList.contains('is-off')) { t = setTimeout(step, 900); return; }
      var g = gs[k % gs.length];
      g.classList.remove('is-lit'); void g.offsetWidth; g.classList.add('is-lit');
      k++;
      t = setTimeout(step, (k % gs.length === 0) ? 3200 : 340);
    }
    t = setTimeout(step, 600);
  }

  function abrir(key) {
    var manual = document.querySelector('input[data-nm-customize="manual"]');
    if (!manual) return;
    if (!manual.checked) manual.click();
    setTimeout(function () {
      var sel = document.querySelector('[data-nm-nameset-select]'), alvo = PILL[key];
      /* pela KEY do botao: o rotulo muda por idioma (Hongkong em de/nl/pl) e o texto nao casava */
      var bt = sel && sel.querySelector('.ntm-nameset-opt[data-key="' + key + '"]');
      if (bt) { bt.click(); alvo = null; }
      if (sel && alvo) {
        var all = sel.querySelectorAll('*');
        for (var i = 0; i < all.length; i++) {
          if (all[i].children.length === 0 && (all[i].innerText || '').trim() === alvo) { all[i].click(); break; }
        }
      }
      var pv = document.querySelector('.ntm-preview-shirt') || manual;
      if (pv && pv.scrollIntoView) pv.scrollIntoView({ block: 'center', behavior: RM ? 'auto' : 'smooth' });
    }, 260);
  }

  function preview() {
    var box = document.querySelector('[data-nm-preview-number]');
    if (!box || box.__nsb) return; box.__nsb = 1;
    function marcar() {
      var im = box.querySelectorAll('img');
      for (var i = 0; i < im.length; i++) {
        im[i].classList.toggle('nm-shine', !RM && /wfwbyy-(dragon|gime|thulite|tourmaline|fluorite|marcasite|thomsonite|stilbite|zoisite|trona|anatase|orpiment)-/.test(im[i].src || ''));
      }
    }
    new MutationObserver(marcar).observe(box, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
    marcar();
  }

  /* o trilho sao duas copias iguais e a animacao roda -50%: a metade que passa antes do loop
     fechar precisa ser mais larga que o espaco visivel, senao sobra vazio no fim da faixa.
     Clona a sequencia ate cobrir e recalcula a duracao pra velocidade aparente nao mudar. */
  var VEL = 18;   // px por segundo
  function encher(band) {
    var slot = band.querySelector('.nsb__d'), run = band.querySelector('.nsb__run');
    if (!slot || !run) return;
    var im = run.querySelectorAll('img');
    for (var i = 0; i < im.length; i++) if (!im[i].complete || !im[i].naturalWidth) return;  // so mede com tudo carregado
    if (!run.__u) run.__u = [].slice.call(run.children, 0, run.children.length / 2);
    var alvo = slot.clientWidth, meia = run.scrollWidth / 2, n = 0;
    if (!alvo || !meia) return;
    while (meia < alvo && n++ < 6) {
      for (var c = 0; c < 2; c++) for (var j = 0; j < run.__u.length; j++) run.appendChild(run.__u[j].cloneNode(true));
      meia = run.scrollWidth / 2;
    }
    band.style.setProperty('--nsb-dur', Math.round(meia / VEL) + 's');
  }

  // img lazy so tem largura depois de carregar, e a largura visivel muda no resize: os dois avisam por aqui
  var ro = ('ResizeObserver' in window) ? new ResizeObserver(function (es) {
    for (var i = 0; i < es.length; i++) {
      var b = es[i].target.closest('.nsb--card');
      if (b) encher(b);
    }
  }) : null;

  function boot() {
    preview();
    var bs = document.querySelectorAll('[data-nsb]');
    for (var i = 0; i < bs.length; i++) {
      var b = bs[i];
      if (io && !b.__io) { b.__io = 1; io.observe(b); }
      shine(b);
      if (b.classList.contains('nsb--card') && !b.__fill) {
        b.__fill = 1;
        encher(b);
        if (ro) { ro.observe(b.querySelector('.nsb__run')); ro.observe(b.querySelector('.nsb__d')); }
      }
      if ((b.classList.contains('nsb--cta') || b.classList.contains('nsb--top')) && !b.__clk) {
        b.__clk = 1;
        b.setAttribute('role', 'button');
        b.setAttribute('tabindex', '0');
        b.style.pointerEvents = 'auto';
        (function (el) {
          el.addEventListener('click', function () { abrir(el.getAttribute('data-nsb-key')); });
          el.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); abrir(el.getAttribute('data-nsb-key')); }
          });
        })(b);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
